import { Box, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useContextState } from "../../../../../../hooks/theme"


const StoreStatus = ({ idStore, name }: { idStore: string, name: string }) => {

    const { t } = useTranslation()
    const { colors } = useContextState()

    return (
        <Box
            sx={{
                '& .MuiTypography-root': {
                    color: colors.color10,
                    fontSize: '12px'
                }
            }}
        >
            {name ?
                <Typography>{t('actionPlan.unity', { idUnity: idStore, storeName: name })}</Typography>
                :
                <Typography>N/A</Typography>
            }
        </Box>
    )
}

export default StoreStatus
